export enum FormActionsEnum {
  CREATE = 'CREATE',
  EDIT = 'EDIT'
}

export enum DismissRolesEnum {
  ACCEPT = 'ACCEPT',
  CANCEL = 'CANCEL',
  DISMISS = 'DISMISS',
  SAVE = 'SAVE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  OPTION_1 = 'OPTION 1',
  OPTION_2 = 'OPTION 2',
  OPTION_3 = 'OPTION 3'
}
